module.exports = __webpack_public_path__ + "img/lh-logo.6b1e6a1a.png";